import { render, staticRenderFns } from "./ThgFrequentlyAskedQuestions.vue?vue&type=template&id=8adce8fa&scoped=true"
import script from "./ThgFrequentlyAskedQuestions.vue?vue&type=script&lang=ts"
export * from "./ThgFrequentlyAskedQuestions.vue?vue&type=script&lang=ts"
import style0 from "./ThgFrequentlyAskedQuestions.vue?vue&type=style&index=0&id=8adce8fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adce8fa",
  null
  
)

export default component.exports